
/**
* @author Camilo
* @since  15/11/2017
**/
export class NotasModel{

	constructor(public ctipnota:string, public cnumcont:string, public ciddoc:string, public cnumdoc:string, public dfecmov:string, public nvalbase:number, public nvaliva:number, public nimpuestoconsumo:number,public vobservacion:string,public nporcentaje,public ncodigoconceptonota:string){
	}

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Notas/Notas.model.ts